<section class="page-heading">
  <h1>Payment has been sent</h1>
  <mat-icon svgIcon="sent" class="icon-normal notranslate" />
</section>

@if(isLoading$ | async){
  <terra-loader class="loader" />
} @else {
  <section>
    <mat-card class="wrapper">
      <!--  Left side  -->
      <div class="payment-details">
        <terra-unit-payment-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" />
      </div>
      <!-- Right side -->
      <div class="sender-and-recipient-details">
        <!--  Sender -->
        <span>
          <terra-unit-payment-sender-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" />
        </span>
        <!--  Recipient -->
        <span>
          <terra-unit-payment-recipient-details [payment]="payment$ | async" [sourceBankAccount]="sourceBankAccount$ | async" [isGp]="isGp" />
        </span>
      </div>
    </mat-card>
  </section>


  <div class="notes">
    <span class="title">Please note:</span>
    <span>- You can always track the status of the transaction on the
      <a class="link" target="_blank" [href]="bankAccountPage | async">bank account page</a>.
    </span>
    <button mat-flat-button type="button" *ngIf="(sourceBankAccount$ |async).unitApplication?.holding" color="primary" class="go-to-holding" (click)="navigateToHoldingPage()">
      Go to Holding
    </button>
  </div>
}
